import { Option } from 'shared/models/common';

function buildDictionary<T extends object, K extends keyof T>(
  collection: T[],
  inputKey: K
) {
  let dictionary = new Map<T[K], T>();

  for (let entity of collection) {
    const inputKeyValue = entity[inputKey];

    dictionary.set(inputKeyValue, entity);
  }

  return dictionary;
}

export default function getSelectHelpers<T extends string | number>(
  input: Option<T>[]
) {
  const dictionary = buildDictionary(input, 'Value');
  const getOptionLabel = (option: T) => dictionary.get(option)?.Label ?? '';

  return {
    options: input.map((option) => option.Value),
    getOptionLabel,
  };
}
